(function() {
  if (window.CPBindHorizontalWheelScroll) return;

  window.CPBindHorizontalWheelScroll = function(config) {
    if (!config) return;

    var swiper = config.swiper;
    var wheelTarget = config.wheelTarget;
    var bindKey = config.bindKey || 'wheelBound';
    var isActive = typeof config.isActive === 'function' ? config.isActive : function() { return true; };
    var lockMs = typeof config.lockMs === 'number' ? config.lockMs : 450;
    var horizontalBias = typeof config.horizontalBias === 'number' ? config.horizontalBias : 2;
    var minDelta = typeof config.minDelta === 'number' ? config.minDelta : 4;

    if (!swiper || !wheelTarget || wheelTarget.dataset[bindKey] === 'true') return;

    wheelTarget.style.overscrollBehaviorX = 'contain';
    wheelTarget.style.touchAction = 'pan-y';

    var isWheelLocked = false;

    wheelTarget.addEventListener('wheel', function(event) {
      if (!isActive()) return;

      var deltaX = Math.abs(event.deltaX);
      var deltaY = Math.abs(event.deltaY);
      var isHorizontalIntent = deltaX > (deltaY + horizontalBias);

      if (deltaX < minDelta && deltaY < minDelta) return;
      if (!isHorizontalIntent) return;
      if (!swiper || swiper.destroyed) return;

      var direction = event.deltaX;
      if (direction === 0) return;

      var shouldMoveNext = direction > 0;
      var canSlideNext = !swiper.isEnd;
      var canSlidePrev = !swiper.isBeginning;

      if (event.cancelable) {
        event.preventDefault();
      }
      event.stopPropagation();

      if ((shouldMoveNext && !canSlideNext) || (!shouldMoveNext && !canSlidePrev)) return;
      if (isWheelLocked || swiper.animating) return;

      isWheelLocked = true;
      if (shouldMoveNext) {
        swiper.slideNext();
      } else {
        swiper.slidePrev();
      }

      setTimeout(function() {
        isWheelLocked = false;
      }, lockMs);
    }, { passive: false });

    wheelTarget.dataset[bindKey] = 'true';
  };
})();
